/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Best_Feature_5Inputs */

const et_plan_best_feature_5 = /** @type {(inputs: Plan_Best_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium tagalingid`)
};

const en_plan_best_feature_5 = /** @type {(inputs: Plan_Best_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium backlinks`)
};

/**
* | output |
* | --- |
* | "Premium backlinks" |
*
* @param {Plan_Best_Feature_5Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_best_feature_5 = /** @type {((inputs?: Plan_Best_Feature_5Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Best_Feature_5Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_best_feature_5(inputs)
	return en_plan_best_feature_5(inputs)
});